import { render, staticRenderFns } from "./Emailtype.vue?vue&type=template&id=a1cb8558&"
import script from "./Emailtype.vue?vue&type=script&lang=js&"
export * from "./Emailtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports